import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';

import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { ProgrammingUtilsService as Utils } from './../../../common/services/utils.service';
import { CommonProgrammingContext } from './../../../common/services/shared-programming.service';
import { LightsService } from './../services/lights.service';
import { LightSceneDetail } from './../services/interfaces/light.interface';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { LightsProgrammingContext } from '../services/lights.service';
import { DeviceEvent } from '../../../common/interfaces/event.interface';
import { LightSceneRef } from '../services/interfaces/light.interface';


@Component({
  selector: 'prg-light-scene-command',
  templateUrl: './light-scene-command.component.html',
  styleUrls: ['./light-scene-command.component.less']
})
export class LightSceneCommandComponent extends BaseRoutingComponent implements OnInit {

  _scene: Observable<LightSceneDetail>;

  constructor(
    protected router: Router,
    protected store: Store<{
      lightingProgramming: LightsProgrammingContext,
      sharedProgramming: CommonProgrammingContext
    }>,
    private _lights: LightsService,
    private _route: ActivatedRoute
  ) {
    super();
    this._scene = this._lights.scene;
  }

  ngOnInit() {
    console.log('scene-command: route params', this._route.snapshot.params);
    let id = parseInt(this._route.snapshot.params['id']);
    console.log('scene-command: parsed scene id', id);
    if (!isNaN(id)) {
      this._lights.getScene(id);
    }
  }

  addCommand(command: string) {
    this._lights.setSceneCommand(command);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/light-scene-command/light-scene-command.component.ts